module.exports = __webpack_public_path__ + "img/Avatar-82.8b3423b9.svg";